import { Loader, Typography } from "@braintrust/braintrust-ui-components";

import { InvoicePageLayout } from "../../components/invoice-page-layout";
import type { AddInvoiceFormComponentProps } from "../../forms/add-invoice";
import { AddInvoiceForm } from "../../forms/add-invoice";
import { useAddInvoice } from "../../hooks/add-invoice";

export const AddInvoicePage = () => {
  const {
    enableReinitialize,
    onSubmit,
    onSubmitFail,
    onChange,
    onSubmitSuccess,
    initialValues,
    loading,
    canChangeJob,
    isCopy,
    isExpenseOnlyInvoiceForm,
    isInvoiceEditingDisabled,
  } = useAddInvoice();

  const pageTitle = isExpenseOnlyInvoiceForm
    ? "New Expense Only Invoice"
    : "New Invoice";
  return (
    <InvoicePageLayout pageTitle={pageTitle}>
      <Typography
        component="h1"
        variant="title"
        sx={{ textTransform: "uppercase", mb: 1 }}
      >
        {pageTitle}
      </Typography>
      {loading ? (
        <Loader centered />
      ) : (
        <AddInvoiceForm
          enableReinitialize={enableReinitialize}
          isCopy={isCopy}
          canChangeJob={canChangeJob}
          onSubmitFail={onSubmitFail}
          onSubmitSuccess={onSubmitSuccess}
          onSubmit={onSubmit}
          onChange={onChange as AddInvoiceFormComponentProps["onChange"]}
          initialValues={initialValues}
          isExpenseOnlyInvoiceForm={isExpenseOnlyInvoiceForm}
          isInvoiceEditingDisabled={isInvoiceEditingDisabled}
        />
      )}
    </InvoicePageLayout>
  );
};
